


/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETREFERRALSSECTIONBYID
// GETREFERRALSSECTIONBYID


const GETREFERRALSSECTIONBYID= createAsyncThunk(
  "getReferralSectionById/getReferralSectionById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getReferralSectionByIdSlice = createSlice({
  name: "getReferralSectionByIdSlice",
  initialState: {
    getReferralSectionById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetReferralSectionById: (state) => {
        state.getReferralSectionById.loading = false
        state.getReferralSectionById.error = false
        state.getReferralSectionById.data = []
        state.getReferralSectionById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETREFERRALSSECTIONBYID.fulfilled, (state, action) => {
      state.getReferralSectionById = {
        ...state.getReferralSectionById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETREFERRALSSECTIONBYID.pending, (state, action) => {
      state.getReferralSectionById = {
        ...state.getReferralSectionById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETREFERRALSSECTIONBYID.rejected, (state, action) => {
      state.getReferralSectionById = {
        ...state.getReferralSectionById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getReferralSectionByIdAction = {
    GETREFERRALSSECTIONBYID,
};

export { getReferralSectionByIdAction };
export default getReferralSectionByIdSlice.reducer;
export const {setInitialStateOfgetReferralSectionById} = getReferralSectionByIdSlice.actions
